import { JSX } from "react";

interface WorkerCardProps {
    imgSrc: string;
    imgAlt: string;
    workerName: string;
    workerPosition: string;
    shortDescription: JSX.Element | string;
    workerPositionDescription: JSX.Element | string;
    workerCharacteristics: JSX.Element | string
}

export default function WorkerCard({
                                       imgSrc,
                                       imgAlt,
                                       workerName,
                                       workerPosition,
                                       shortDescription,
                                       workerPositionDescription,
                                       workerCharacteristics
                                   }: WorkerCardProps): JSX.Element {
    return (
        <div className="col-md-5">
            <div className="card member-card p-4 shadow-sm">
                <div>
                    <img
                        src={`${imgSrc}`}
                        alt={`${imgAlt}`} className="mx-auto mb-3"/>
                    <h4>{workerName}</h4>
                    <p className="text-muted">{workerPosition}</p>
                    {shortDescription}
                    <hr/>
                    {workerPositionDescription}
                </div>
                <div className="text-start">
                    {workerCharacteristics}
                </div>
            </div>
        </div>
    );
};